/**
 * Reformat params object to string
 * @param  {object} value { page: 2, per_page: 25 }
 * @returns {string} converted to page=2&per_page=25
 */
export function buildParams(params) {
  const searchParams = { ...params };
  return new URLSearchParams(searchParams).toString();
}

export default { buildParams };
